var isMobile = {
    Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};


/* Function set border sidebar */
function harmonySidebarBorder(main, sidebar, line){
  
  jQuery(line).removeAttr('style');
  
  if(getWidthBrowser() > 768){
    var m_height = jQuery(main).outerHeight();
    var s_height = jQuery(sidebar).outerHeight();
    
    var height = 0;
    if(m_height > s_height)
      height = m_height;
    else
      height = s_height;
    
    jQuery(line).css('min-height', height);
  }
}

/* Function add class */
function harmonyAddClass(main, clss){
  
  jQuery(main).last().addClass(clss);
  
}

/* Fucntion get width browser */
function getWidthBrowser() {
	var myWidth;

	if( typeof( window.innerWidth ) == 'number' ) { 
		//Non-IE 
		myWidth = window.innerWidth;
		//myHeight = window.innerHeight; 
	} 
	else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { 
		//IE 6+ in 'standards compliant mode' 
		myWidth = document.documentElement.clientWidth; 
		//myHeight = document.documentElement.clientHeight; 
	} 
	else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { 
		//IE 4 compatible 
		myWidth = document.body.clientWidth; 
		//myHeight = document.body.clientHeight; 
	}
	
	return myWidth;
}

/* if width browser < 1024, then display */
function execWidthLess1024(){
  
  if(getWidthBrowser() < 1024 || (getWidthBrowser() == 1024 && isMobile.any())){
    
    var $hover = jQuery('.pretty_hover');
    
    jQuery.each($hover, function(i, val) {
      
      var $this = jQuery(this);
      var $caption = $this.find('.pretty_caption');
      $caption.show();
      var $height = $caption.outerHeight();
      	
      $caption.show().animate({top: (1 - $height) + "px"}, 0);
    });
  }else{
    var $hover = jQuery('.pretty_hover');
    
    jQuery.each($hover, function(i, val) {
      
      var $this = jQuery(this);
      var $caption = $this.find('.pretty_caption');
      $caption.css({top: "0"});
    });
  }
}

$(window).resize(function() {
  
  execWidthLess1024();

});

$(function() {
  
  $("img.unveil").unveil(300);
  
  /* Quantity */
  $('.selector-wrapper').on('click', '.qty-up', function() {
    var $this = $(this);
    
    var qty = $this.data('src');
    $(qty).val(parseInt($(qty).val()) + 1);
  });
  
  $('.selector-wrapper').on('click', '.qty-down', function() {
    var $this = $(this);
    
    var qty = $this.data('src');
    
    if(parseInt($(qty).val()) > 1)
    	$(qty).val(parseInt($(qty).val()) - 1);
  });

  execWidthLess1024();
  
  /* Tooltip */
  if($('.tooltip-tipsy').length)
  $('.tooltip-tipsy').tipsy({
    gravity: 'n',
    fade: true,
    opacity: 1
  });
  
  /* Hover display caption */
  $('.pretty_hover').on('mouseover', function() {
    
    if(getWidthBrowser() >= 1024){
      
      var $this = $(this);
      var $caption = $this.find('.pretty_caption');
      $caption.show();
      var $height = $caption.outerHeight();
      
      //$(this).css({opacity: ".7"}, 0);		
      $caption.show().animate({top: (1 - $height) + "px"}, 0);
    }
  }).on('mouseout', function() {
    
    if(getWidthBrowser() >= 1024){
      
      var $this = $(this);
      var $caption = $this.find('.pretty_caption');
      var $height = $caption.outerHeight();
      
      //$(this).css({opacity: "1.0"}, 0);					
      $caption.hide().css({top: "0"});
    }
  });
  
  /* Quick Shop hover */
  $('.product-item').on('mouseover', function() {
    var $this = $(this);
    var $off = $this.offset();
    var $qshop = $this.find('.quick_shop');

    $qshop.css({
      'top': (($this.height() / 2) - ($qshop.outerHeight() / 2)) + 'px',
      'left': (($this.width() / 2) - ($qshop.outerWidth() / 2)) + 'px'
    }).show();
    
  }).on('mouseout', function() {
    var $this = $(this);
    var $qshop = $this.find('.quick_shop');

    $qshop.css({
      'top': '0',
      'left': '0'
    }).hide();
    
  });
  
  $('.thumbnail .list-left').on('mouseover', function() {
    var $this = $(this);
    var $off = $this.offset();
    var $qshop = $this.find('.quick_shop');

    $qshop.css({
      'top': (($this.height() / 2) - ($qshop.outerHeight() / 2)) + 'px',
      'left': (($this.width() / 2) - ($qshop.outerWidth() / 2)) + 'px'
    }).show();
    
  }).on('mouseout', function() {
    var $this = $(this);
    var $qshop = $this.find('.quick_shop');

    $qshop.css({
      'top': '0',
      'left': '0'
    }).hide();
    
  });
  
  
  /* Carts */
  $('#cart-info').hide();
  $('.cart-link .num-items-in-cart').bind('mouseover',showcart).bind('mouseout', hidecart);
  $('#cart-info').bind('mouseover',showcart).bind('mouseout', hidecart);
  
  function showcart() {
    $('#cart-info').show();	
  }
  
  function hidecart() {
    $('#cart-info').hide();
  }
  
  
  /* Sort */
  $('select#sortBox').change(function(){  // add event any time the sort box changes
    
    arr = []
    sort_func = $(this).children(':selected').val(); //grab the value of the sort box
    
    $('li.collectionItem').each(function(){ // collect all the product items and add to an array
      arr.push(this);
    });
    
    // find which sort was selected and run the right sort function
    if (sort_func == "a_z"){
      arr.sort(compare_a_z);
    }
    else if (sort_func == "z_a"){
      arr.sort(compare_z_a);
    }
      else if (sort_func == "l_h"){
        arr.sort(compare_l_h);
      }
      else if (sort_func == "h_l"){
        arr.sort(compare_h_l);
      }
        // push the arranged products back out
        $('#collectionListing').append(arr);
  });
  
  // custome sort functions
  function compare_a_z(a, b){
    var compA = $(a).data('alpha');
    var compB = $(b).data('alpha');
    return (compA < compB) ? -1 : (compA > compB ) ? 1 : 0;
  }
  
  function compare_z_a(a, b){
    var compA = $(a).data('alpha');
    var compB = $(b).data('alpha');
    return (compA > compB) ? -1 : (compA < compB ) ? 1 : 0;
  }
  
  function compare_l_h(a, b){
    var compA = $(a).data('price');
    var compB = $(b).data('price');
    return (compA < compB) ? -1 : (compA > compB ) ? 1 : 0;
  }
  
  function compare_h_l(a, b){
    var compA = $(a).data('price');
    var compB = $(b).data('price');
    return (compA > compB) ? -1 : (compA < compB ) ? 1 : 0;
  }
  
  
  /* Grid - List */
  $("a.switcher").bind("click", function(e){
    e.preventDefault();
    
    var theid = $(this).attr("id");
    var theproducts = $("#collectionListing");
    var classNames = $(this).attr('class').split(' ');
    
    if($(this).parent().hasClass("active")) {
      // if currently clicked button has the active class
      // then we do nothing!
      return false;
    } else {
      // otherwise we are clicking on the inactive button
      // and in the process of switching views!
      
      if(theid == "gridview") {
        $(this).parent().addClass("active");
        $("#listview").parent().removeClass("active");
        
        // remove the list class and change to grid
        theproducts.removeClass("list");
        theproducts.addClass("grid");
        
      }
      
      else if(theid == "listview") {
        $(this).parent().addClass("active");
        $("#gridview").parent().removeClass("active");
        
        // remove the grid view and change to list
        theproducts.removeClass("grid")
        theproducts.addClass("list");
      } 
        }
    
  });
  
  /* selectCallback */
  selectOptionsCallback = function(variant, selector) {
    iStockVariantObj = variant;
    var add_to_cart = '#add-to-cart';
    var $price = '#purchase-' + selector.product.id.toString() + ' .detail-price';
    var $inventory = '.product-' + selector.product.id.toString() + ' #inventory';
    var $sku_holder = '.product-' + selector.product.id.toString() + ' .sku_holder';
    var newinventory = variant.inventory_quantity;
    var productvariants = null;
 	var currentvariant = variant.title;
 	currentvariant = currentvariant.replace(/Trade EC VAT/g,'').replace('()','').replace('()','').replace('  ',' ');
    currentvariant = currentvariant.replace(/Trade/g,'').replace('()','').replace('()','').replace('  ',' ');

    if (variant && variant.available) {
     if(newinventory < 1) {
          $($inventory).html('<span class="outofstock">0 in stock</span>');
    			//swal({   title: "",   text: "This product is currently out of stock!",   type: "error",   confirmButtonText: "Close" });
			
        } else {
          $($inventory).html('<span class="instock">' + newinventory + ' in stock</span>');
          $('#stock-msg').css('display','none');
        }
      
       if (variant && variant.featured_image) {
        var originalImage = $("#product_slider img");
        var newImage = variant.featured_image;
        var element = originalImage[0];
        Shopify.Image.switchImage(newImage, element, function (newImageSizedSrc, newImage, element) {
            $(element).parents('a').attr('href', newImageSizedSrc);
            $(element).attr('src', newImageSizedSrc);
        });
       }
      
      // selected a valid variant
      $(add_to_cart).removeClass('disabled').removeAttr('disabled'); // remove unavailable class from add-to-cart button, and re-enable button
      
      if(variant.compare_at_price == null){
        $($price).html('<span class="money">'+Shopify.formatMoney(variant.price, "")+'</span> <span class="vat">+ VAT </span>');
        $($sku_holder).html('Part no:  <span class="sku">' + variant.sku + '</span>'); 
        $('[name=currencies]').change();
        
      } else {
        $($price).html('<span class="money">'+Shopify.formatMoney(variant.price, "") + '</span> <span class="compare_at_price"> <del><span class="money">' + Shopify.formatMoney(variant.compare_at_price, "") + '</span></del></span>');
        
        $('[name=currencies]').change();
      }
    } else {
      $(add_to_cart).addClass('disabled').attr('disabled', 'disabled'); // set add-to-cart button to unavailable class and disable button
      var message = variant ? "Sold Out" : "Unavailable";
      $($price).addClass('unavailable').html(message); // update price-field message
    }
  };
});
  

  
